import { Component, Input } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { QuestionApiModel } from '@public/src/api/generated/models';
import { DynamicFormAnswer } from './DynamicFormAnswer';

@Component({
	standalone: false,
	selector: 'dfq-yesno',
	template: /*language=html*/ `
		<h3>
			<span>{{ data.questionNumber }}</span> {{ data.Header }} <span class="required" *ngIf="data.Required">*</span>
		</h3>
		<div class="row input">
			<visiba-input
				type="radio"
				[formControl]="formControl"
				[(ngModel)]="value"
				(onChange)="valueChange()"
				[options]="[
					{ value: true, label: data.TrueLabel },
					{ value: false, label: data.FalseLabel },
				]"
				[readonly]="readonly"
			></visiba-input>
		</div>
	`,
})
export class DfqYesNoComponent {
	@Input() formId: number = null;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	@Input() data: any = null;
	@Input() readonly = false;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	value: any = null;

	formControl: UntypedFormControl = null;

	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	constructor() {}

	ngOnInit() {
		if (typeof this.data.Answer === 'undefined' || this.data.Answer === null)
			// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
			(this.data as any).Answer = new DynamicFormAnswer(null, this.data.Id, this.valid);
		else {
			// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
			(this.data.Answer as any).Valid = this.valid;
			this.value = this.data.Answer.BoolValue;
		}

		const validators = [];
		if (this.data.Required) validators.push(Validators.required);

		this.formControl = new UntypedFormControl(null, validators);
	}

	valueChange = () => {
		this.data.Answer.BoolValue = this.value;
	};

	valid = (): boolean => {
		return !this.data.Required || this.data.Answer.BoolValue != null;
	};
}
